
import './homeBanner.scss';
import BannerSliderNav from '@src/components/sections/homeBanner/components/bannerSliderNav';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Box, Container } from 'theme-ui';

const BannerLayer = ({ color, children, className }) => {
  // console.warn(className);

  return <Box
    className={`home-banner__layer ${className}`}
    sx={{
      backgroundColor: color || 'white',
      position: 'absolute',
      overflow: 'hidden',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    }}
  >
    {children}
  </Box >
};


const HomeBanner = ({ subjects, children }) => {
  // return (<></>);
  // TODO: fix this cpu and memory consuming component
  const subjectsInfo = subjects.map((subject, index) => {
    return {
      image: getImage(subject.image.image),
      title: subject.name,
      slug: subject.slug,
      color: subject.image.color.backgroundColor,
    };
  });

  // const randomIndex = Math.floor(Math.random() * subjects.length);
  const randomIndex = 0;
  const [activeSubjectIndex, setActiveSubjectIndex] = useState(randomIndex);
  const [animateClass, setAnimateClass] = useState('');
  const [bgLayer, setBgLayer] = useState(0);

  const currentSubject = {
    title: subjectsInfo[activeSubjectIndex]?.title || '',
    slug: subjectsInfo[activeSubjectIndex]?.slug || '',
  };

  const nextIndex = (activeSubjectIndex + 1) % subjectsInfo.length;
  const prevIndex =
    (activeSubjectIndex + subjectsInfo.length - 1) % subjectsInfo.length;

  // have to be the same with css animation duration in _home-banner-vars.scss file
  const animationDuration = 2000;
  const autoLoopDuration = 5000;

  const nextImage = () => {
    setBgLayer(1);
    setAnimateClass('slide-left');

    const timer = setTimeout(() => {
      setBgLayer(0);
      setAnimateClass('');
      setActiveSubjectIndex(nextIndex);
      clearTimeout(timer);
    }, animationDuration);
  };

  const prevImage = () => {
    setBgLayer(2);
    setAnimateClass('slide-left');

    const timer = setTimeout(() => {
      setBgLayer(0);
      setAnimateClass('');
      setActiveSubjectIndex(prevIndex);
      clearTimeout(timer);
    }, animationDuration);
  };

  let interval = null;
  useEffect(() => {
    setActiveSubjectIndex(Math.floor(Math.random() * subjects?.length))
  }, []);
  useEffect(() => {
    interval = setInterval(() => {
      nextImage();
    }, autoLoopDuration);

    return () => clearInterval(interval);
  }, [activeSubjectIndex]);

  return (
    <Box className={`home-banner ${animateClass}`}>
      {(bgLayer === 0 || bgLayer === 1) && (
        <BannerLayer
          className="back-layer"
          color={subjectsInfo[nextIndex]?.color || '#fff'}
        >
          <GatsbyImage
            className="home-banner__layer-image"
            loading="eager"
            image={subjectsInfo[nextIndex]?.image || ''}
            alt=""
          />
        </BannerLayer>
      )}
      {(bgLayer === 0 || bgLayer === 2) && (
        <BannerLayer
          className="back-layer"
          color={subjectsInfo[prevIndex]?.color || '#fff'}
        >
          <GatsbyImage
            className="home-banner__layer-image"
            loading="eager"
            image={subjectsInfo[prevIndex]?.image || ''}
            alt=""
          />
        </BannerLayer>
      )}
      <BannerLayer
        className="top-layer"
        color={subjectsInfo[activeSubjectIndex]?.color || '#fff'}
      >
        <GatsbyImage
          className="home-banner__layer-image"
          image={subjectsInfo[activeSubjectIndex]?.image || ''}
          alt=""
        />
      </BannerLayer>

      <Box sx={{ position: 'relative', zIndex: 2 }}>{children}</Box>

      <Container sx={{ position: 'relative', zIndex: 2 }}>
        <BannerSliderNav
          animationDuration={animationDuration}
          subjectInfo={currentSubject}
          onNext={nextImage}
          onPrev={prevImage}
        />
      </Container>
    </Box>
  );
};

export default HomeBanner;
